import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translations (public site only — no admin/login namespaces)
import enCommon from "@/locales/en/common.json";
import enForms from "@/locales/en/forms.json";
import enErrors from "@/locales/en/errors.json";
import enLanding from "@/locales/en/landing.json";
import enLegal from "@/locales/en/legal.json";
import enEmailVerification from "@/locales/en/emailVerification.json";
import enSupport from "@/locales/en/support.json";

import ruCommon from "@/locales/ru/common.json";
import ruForms from "@/locales/ru/forms.json";
import ruErrors from "@/locales/ru/errors.json";
import ruLanding from "@/locales/ru/landing.json";
import ruLegal from "@/locales/ru/legal.json";
import ruEmailVerification from "@/locales/ru/emailVerification.json";
import ruSupport from "@/locales/ru/support.json";

import kzCommon from "@/locales/kz/common.json";
import kzForms from "@/locales/kz/forms.json";
import kzErrors from "@/locales/kz/errors.json";
import kzLanding from "@/locales/kz/landing.json";
import kzLegal from "@/locales/kz/legal.json";
import kzEmailVerification from "@/locales/kz/emailVerification.json";
import kzSupport from "@/locales/kz/support.json";

const resources = {
  en: {
    common: enCommon,
    forms: enForms,
    errors: enErrors,
    landing: enLanding,
    legal: enLegal,
    emailVerification: enEmailVerification,
    support: enSupport,
  },
  ru: {
    common: ruCommon,
    forms: ruForms,
    errors: ruErrors,
    landing: ruLanding,
    legal: ruLegal,
    emailVerification: ruEmailVerification,
    support: ruSupport,
  },
  kz: {
    common: kzCommon,
    forms: kzForms,
    errors: kzErrors,
    landing: kzLanding,
    legal: kzLegal,
    emailVerification: kzEmailVerification,
    support: kzSupport,
  },
};

// Initialize i18n synchronously to prevent TDZ errors
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultNS: "common",
    fallbackLng: "en",
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "loyrush-language",
    },

    initImmediate: false,
  });

export default i18n;
